var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRatingField(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#595959"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.997 11.118l.5-2.782c.03-.164-.027-.333-.153-.449L1.24 5.917c-.215-.2-.293-.501-.2-.775.092-.274.34-.474.637-.515l2.916-.409c.17-.024.319-.128.394-.277l1.306-2.52C6.426 1.163 6.7 1 7 1c.3 0 .575.163.708.421l1.306 2.52c.075.15.223.253.394.277l2.916.409c.298.041.545.241.638.515.092.274.014.574-.201.775l-2.105 1.97c-.125.115-.181.281-.153.444l.5 2.782c.04.22-.023.447-.174.617-.15.172-.372.27-.605.27l.005-.005c-.128 0-.254-.029-.368-.086l-2.632-1.315c-.153-.077-.337-.077-.49 0l-.6.302",
    transform: "translate(-153 -839) translate(121 828) translate(32 11)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingField);
export default __webpack_public_path__ + "static/media/rating-field.01f01479.svg";
export { ForwardRef as ReactComponent };